/*
 * @Author: tony.zhu
 * @Date: 2024-10-18 15:23:27
 * @LastEditTime: 2024-10-18 16:51:01
 * @LastEditors: tony.zhu
 * @Description: 表格表头吸顶指令
 */

import { debounce } from 'throttle-debounce'

// 头部吸顶
const stickyThead = function (el, binging, vnode) {
  let top = '0px';
  if (!isNaN(Number(binging.value))) {
    top = binging.value + 'px';
  }
  if (typeof binging.value === 'string' && document.querySelector(binging.value)) {
    const rect = document.querySelector(binging.value).getBoundingClientRect();
    top = rect ? rect.top + rect.height + 'px' : '0px';
  }

  el.children[0].style.overflow = 'visible';
  const tHeader = el.querySelector('.el-table__header-wrapper');
  tHeader.style.position = 'sticky';
  tHeader.style.top = top;
  tHeader.style.zIndex = 20;

  // 移除is-hidden
  const ths = tHeader.querySelectorAll('th.is-hidden');
  ths.forEach(function (item) {
    item.classList.remove('is-hidden');
  });

  // 找到实例
  const table = vnode.context.$children.find(function (item) {
    return item.$el === el;
  });
  table && table.doLayout();
  // 找到左边固定列
  const leftFixed = table.fixedColumns;
  if (leftFixed && leftFixed.length) {
    let leftFixedWidth = 0;
    leftFixed.forEach(function (item) {
      const cell = tHeader.querySelector('th.' + item.id);
      if (cell) {
        let itemW = cell.getBoundingClientRect().width;
        cell.style.position = 'sticky';
        cell.style.left = leftFixedWidth + 'px';
        cell.style.top = top;
        cell.style.zIndex = 10;
        leftFixedWidth += itemW;
      }
    });
  }

  // 找到右边固定列
  const rightFixed = table.rightFixedColumns;
  if (rightFixed && rightFixed.length) {
    let rightFixedWidth = 0;
    for (let i = rightFixed.length - 1; i >= 0; i--) {
      let cell = tHeader.querySelector('th.' + rightFixed[i].id);
      if (cell) {
        let itemW = cell.getBoundingClientRect().width;
        cell.style.position = 'sticky';
        cell.style.right = rightFixedWidth + 'px';
        cell.style.top = top;
        cell.style.zIndex = 10;
        rightFixedWidth += itemW;
      }
    }
  }
};

// 简易吸顶
const sticky = function (el, binging, vnode) {
  let top = '0px';
  if (!isNaN(Number(binging.value))) {
    top = binging.value + 'px';
  }
  if (typeof binging.value === 'string' && document.querySelector(binging.value)) {
    const rect = document.querySelector(binging.value).getBoundingClientRect();
    top = rect ? rect.top + rect.height + 'px' : '0px';
  }
  
  el.children[0].style.overflow = 'visible';
  
  const tHeader = el.querySelector('.el-table__header-wrapper');
  tHeader.style.position = 'sticky';
  tHeader.style.top = top;
  tHeader.style.zIndex = 20;
};


let tableOb = null;
const tableHeaderStickyDir = {
  inserted: function inserted(el, binging, vnode) {
    // 将dom节点的overflow属性设置为visible
    // 因为sticky 不能让父级为hidden
    const appBox = document.getElementById('app');
    if (appBox) {
      appBox.style.overflow = 'visible';
    }
    const appMainBox = document.querySelector('.app-main');
    if (appMainBox) {
      el.appMainHeight = appMainBox.style.height;
      appMainBox.style.minHeight = el.appMainHeight;
      appMainBox.style.overflow = 'visible';
      appMainBox.style.height = '100%';
    }
    
    if (binging.modifiers.fixed) {
      // 监听表格变化
      tableOb = new ResizeObserver((0, debounce)(function () {
        stickyThead(el, binging, vnode);
      }, 500));
      tableOb.observe(el);
    } else {
      sticky(el, binging, vnode);
    }
  },
  unbind: function unbind(el, binging, vnode) {
    // 解绑时 还原属性
    const appBox = document.getElementById('app');
    if (appBox) {
      appBox.style.overflow = 'hidden';
    }
    const appMainBox = document.querySelector('.app-main');
    if (appMainBox) {
      //appMainBox.style.overflow = 'hidden';
      appMainBox.style.removeProperty('overflow');//还原成默认值，不能是hidden，直接去除掉这个js增加的属性，不然很多页面滚不动 264286
      appMainBox.style.minHeight = "";
      appMainBox.style.height = el.appMainHeight;
    }
    tableOb && tableOb.unobserve(el);
  }
}

export default {
  tableHeaderStickyDir
}
